export function showRegister() {
  return process.env.REACT_APP_SHOW_REGISTER === '1';
}
